// extracted by mini-css-extract-plugin
export default {"container":"Yori_container__7U1X3","image":"Yori_image__n3-mb","linkContainer":"Yori_linkContainer__aAZWl","button":"Yori_button__PnnLL"};